export default {
    state: {
        globalLoading: false,
    },
    mutations: {
        setGlobalLoading(state, val) {
            state.globalLoading = val
        },
    },
    actions: {
        setGlobalLoading({commit}, val) {
            console.log(val)
            commit('setGlobalLoading', val)
        }
    }
    
}